import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import QrCodeGenerator from "./components/generator/ganerator"; // Check spelling: "ganerator" might be "generator"
import OfferingForm2 from "./components/offering/offering2";
import TransactionDashboard from "./components/transaction/TransactionDashboard";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<OfferingForm2 />} />
          <Route path="/dashboard" element={<TransactionDashboard />} />
          <Route path="/qr" element={<QrCodeGenerator />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
